// import React, { useEffect, useRef, useState } from "react";
// import {
//   Accordian,
//   Backdrop,
//   Button,
//   FormFieldSet,
//   LogoLoader,
//   Modal,
//   NewTable,
//   showToast,
// } from "../../../../components";
// import { mapTableRows } from "../../../../utils/mapTableRows";
// import { dateFormator, getEmployeeId } from "../../../../utils";
// import { accordionData } from "../../../../assets/data/candidatesData";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   clearEmployeeData,
//   getEmployeesStart,
//   updateEmployeeStart,
// } from "../../../../redux/slices/employee/employeeSlice";
// import { getEmployeeName } from "../../../../utils/getDisplays";
// import useDropdownData from "../../../../hooks/useDropdownData";

// const Approvals = () => {
//   // const approvalGroups = [
//   //   {
//   //     groupTitle: "Internal Approvals",
//   //     approvers: [
//   //       {
//   //         key: "abhiInternal",
//   //         name: "Abhi Y",
//   //         tableId: "internalAbhi",
//   //         rows: JSON.parse(JSON.stringify(accordionData)),
//   //       },
//   //       {
//   //         key: "hemalatheInternal",
//   //         name: "Hemalathe Medishetti",
//   //         tableId: "internalHemalathe",
//   //         rows: JSON.parse(JSON.stringify(accordionData)),
//   //       },
//   //       {
//   //         key: "waseemInternal",
//   //         name: "Abdul Waseem Syed",
//   //         tableId: "internalWaseem",
//   //         rows: JSON.parse(JSON.stringify(accordionData)),
//   //       },
//   //     ],
//   //   },
//   // ];
//   const [approvalGroups, setApprovalGroups] = useState([]);
//   const containerRef = useRef(null);
//   const [user, setUser] = useState("");

//   const [changeApproverModal, setChangeApproverModal] = useState(false);
//   const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
//   const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);

//   const dispatch = useDispatch();
//   const { loading, error, employees, totalCount } = useSelector(
//     (state) => state.employee,
//   );
//   // dropdown hook
//   const {
//     data: allSelectEmployeeListOptions,
//     searchValue: allSelectEmployeeSearch,
//     handleSearch: handleSelectEmployeeSearch,
//     resetSearch: resetAllSelectEmployeeSearch,
//     handleScroll: handleAllSelectEmployeeScroll,
//   } = useDropdownData(
//     "employeesSorted",
//     10,
//     {},
//     {
//       classification: 2,
//     },
//   );
//   // working one
//   // useEffect(() => {
//   //   if (!employees?.data?.length) return;

//   //   const generateApprovalGroups = async () => {
//   //     const approvers = await Promise.all(
//   //       employees.data.map(async (emp) => {
//   //         let rows = [];

//   //         if (emp?.approvalFlow?.approverTo?.length > 0) {
//   //           rows = await Promise.all(
//   //             emp.approvalFlow.approverTo.map(async (approval) => {
//   //               const approver = approval?.approvalFlow?.approvers?.[0]?.uiid;
//   //               const approverName = approver
//   //                 ? await getEmployeeName(approver)
//   //                 : "-";

//   //               return {
//   //                 uiid: approval?.uiid,
//   //                 employeeName: `${approval.firstName} ${
//   //                   approval.lastName
//   //                 } ${getEmployeeId(approval?.uiid, approval?.employmentType)}`,
//   //                 approvals:
//   //                   approverName +
//   //                   " " +
//   //                   getEmployeeId(
//   //                     approval?.approvalFlow?.approvers?.[0]?.uiid,
//   //                     approval?.approvalFlow?.approvers?.[0]?.employmentType
//   //                   ),
//   //                 // jobCode: approval?.jobCode || "-",
//   //                 // jobTitle: approval?.jobTitle || "-",
//   //                 // startDate: approval?.startDate || "-",
//   //                 // endDate: approval?.endDate || "-",
//   //               };
//   //             })
//   //           );
//   //         }

//   //         return {
//   //           key: emp.uiid,
//   //           name: `${emp.firstName} ${emp.lastName} ${emp.uiid}`,
//   //           tableId: `internal${emp.firstName}`,
//   //           rows,
//   //         };
//   //       })
//   //     );

//   //     setApprovalGroups([
//   //       {
//   //         groupTitle: "Internal Approvals",
//   //         approvers: Array.from(new Set(approvers)),
//   //       },
//   //     ]);
//   //   };

//   //   generateApprovalGroups();
//   // }, [employees]);
//   useEffect(() => {
//     if (!employees?.data?.length) return;

//     const generateApprovalGroups = async () => {
//       const approvers = await Promise.all(
//         employees.data.map(async (emp) => {
//           let rows = [];

//           if (emp?.approvalFlow?.approverTo?.length > 0) {
//             rows = await Promise.all(
//               emp.approvalFlow.approverTo.map(async (approval) => {
//                 // const approver = approval?.approvalFlow?.approvers?.[0]?.uiid;
//                 // const approverName = approver
//                 //   ? await getEmployeeName(approver)
//                 //   : "-";

//                 return {
//                   uiid: approval?.uiid,
//                   employeeName:
//                     `${approval.firstName} ${approval.lastName} ${getEmployeeId(
//                       approval?.uiid,
//                       approval?.employmentType,
//                     )}` || "-",
//                   approvals:
//                     approval?.approvalFlow?.approvers?.[0]?.firstName +
//                     " " +
//                     approval?.approvalFlow?.approvers?.[0]?.lastName +
//                     " " +
//                     getEmployeeId(
//                       approval?.approvalFlow?.approvers?.[0]?.uiid,
//                       approval?.approvalFlow?.approvers?.[0]?.employmentType,
//                     ),
//                   // jobCode: approval?.jobCode || "-",
//                   // jobTitle: approval?.jobTitle || "-",
//                   // startDate: approval?.startDate || "-",
//                   // endDate: approval?.endDate || "-",
//                 };
//               }),
//             );
//           }

//           return {
//             key: emp.uiid,
//             name: `${emp.firstName} ${emp.lastName}`,
//             tableId: `internal${emp.firstName}`,
//             rows,
//           };
//         }),
//       );

//       setApprovalGroups([
//         {
//           groupTitle: "Internal Approvals",
//           approvers: Array.from(new Set(approvers)),
//         },
//       ]);
//     };

//     generateApprovalGroups();
//   }, [employees]);

//   useEffect(() => {
//     dispatch(
//       getEmployeesStart({
//         page: 1,
//         limit: 20,
//         filters: {
//           classification: {
//             type: "NONE",
//             value: 2,
//           },
//         },
//         sort: { uiid: -1 },
//         // sort: { uiid: 1 },
//         ret: "uiid firstName lastName approvalFlow employmentType",
//         ref: "Approved_Approver",
//         incl: "uiid firstName lastName employmentType",
//       }),
//     );
//     return () => {
//       dispatch(clearEmployeeData());
//     };
//   }, [dispatch]);

//   const initialOpenStates = {};
//   approvalGroups.forEach((group) =>
//     group.approvers.forEach((a) => {
//       initialOpenStates[a.key] = false;
//     }),
//   );

//   const [openStates, setOpenStates] = useState(initialOpenStates);

//   const toggleAccordion = (key) =>
//     setOpenStates((prev) => ({ ...prev, [key]: !prev[key] }));

//   const getBaseColumns = () => [
//     { key: "employeeName", label: "Employee Name", sortable: false },
//     // { key: "jobCode", label: "Job Code", sortable: false },
//     // { key: "jobTitle", label: "Job Title", sortable: false },
//     // {
//     //   key: "startDate",
//     //   label: "Start Date",
//     //   render: (row) => dateFormator(row.startDate, "month-day-year"),
//     //   sortable: false,
//     // },
//     // {
//     //   key: "endDate",
//     //   label: "End Date",
//     //   render: (row) => dateFormator(row.endDate, "month-day-year"),
//     //   sortable: false,
//     // },
//     { key: "approvals", label: "Approvals", sortable: false },
//   ];
//   const [selectedApprover, setSelectedApprover] = useState(null);
//   const handleCheckBox = (ids, approver) => {
//     if (!approver.key) {
//       showToast("Please select an employee", "error", 5000);
//       return;
//     }
//     setSelectedApprover(approver.key);
//     try {
//       const parsedIds = ids.map((id) => JSON.parse(id));
//       setSelectedEmployeeIds(parsedIds.map((id) => id.uiid));
//       setSelectedEmployeeNames(parsedIds.map((id) => id.employeeName));
//     } catch (error) {
//       console.error("Error parsing IDs:", error);
//     }
//   };

//   //working
//   const handleChangeApprover = async (approver) => {
//     if (!selectedEmployeeIds.length) {
//       showToast("Please select an employee", "error", 5000);
//       return;
//     }

//     try {
//       for (const id of selectedEmployeeIds) {
//         try {
//           await Promise.all([
//             dispatch(
//               updateEmployeeStart({
//                 coll: "Employee",
//                 uiid: id,
//                 payload: [
//                   {
//                     type: "SET",
//                     value: { "approvalFlow.approvers.0": user },
//                   },
//                 ],
//               }),
//             ),
//             dispatch(
//               updateEmployeeStart({
//                 coll: "Employee",
//                 uiid: user,
//                 payload: [
//                   {
//                     type: "PUSH",
//                     value: {
//                       "approvalFlow.approverTo": id,
//                     },
//                   },
//                 ],
//               }),
//             ),
//             dispatch(
//               updateEmployeeStart({
//                 coll: "Employee",
//                 uiid: selectedApprover,
//                 payload: [
//                   {
//                     type: "PULL",
//                     value: {
//                       "approvalFlow.approverTo": id,
//                       // "approvalFlow.approverTo": selectedApprover,
//                     },
//                   },
//                 ],
//               }),
//             ),
//           ]).then(() => {
//             setUser("");
//             setChangeApproverModal(false);

//             setTimeout(() => {
//               dispatch(
//                 getEmployeesStart({
//                   page: 1,
//                   limit: 20,
//                   filters: {
//                     classification: {
//                       type: "NONE",
//                       value: 2,
//                     },
//                   },
//                   sort: { uiid: -1 },
//                   // sort: { uiid: 1 },
//                   ret: "uiid firstName lastName approvalFlow employmentType",
//                   ref: "Approved_Approver",
//                   incl: "uiid firstName lastName employmentType",
//                 }),
//               );
//             }, 1200);
//           });
//         } catch (err) {
//           showToast(`Failed to update employee ${id}`, "error", 5000);
//           console.error(`Error updating employee ${id}:`, err);
//           throw err; // Remove this line if you want to continue even after one fails
//         }
//       }
//     } catch (finalError) {
//       showToast("Bulk update failed. Please try again later.", "error", 5000);
//       console.error("Bulk update error:", finalError);
//     }
//   };

//   return (
//     <div className="py-3 pl-2 overflow-auto">
//       <Backdrop isOpen={loading}>
//         <LogoLoader />
//       </Backdrop>
//       <div className="flex justify-end">
//         <Button
//           variant="contained"
//           size="sm"
//           title="Change Approver"
//           color="black"
//           icon="person_add"
//           onClick={() => setChangeApproverModal(true)}
//         />
//       </div>

//       <div className="space-y-3 mt-3">
//         {approvalGroups.map((group) => (
//           <Accordian
//             key={group.groupTitle}
//             title={group.groupTitle}
//             iconColor="black"
//             color="white"
//             rounded="md"
//           >
//             <div className="space-y-1 overflow-auto">
//               {group.approvers.map((approver) => (
//                 <div
//                   key={approver.key}
//                   className={openStates[approver.key] ? "" : "inline-flex m-2"}
//                 >
//                   <Accordian
//                     title={approver.name}
//                     iconType="variant"
//                     iconColor="black"
//                     rounded="md"
//                     color="primary"
//                     handleChangeOption={() => {
//                       setSelectedEmployeeIds([]);
//                       setSelectedEmployeeNames([]);
//                       toggleAccordion(approver.key);
//                     }}
//                     bodyPadding="px-0 py-0"
//                   >
//                     <NewTable
//                       tableId={approver.tableId}
//                       showCheckbox
//                       limit={20}
//                       rows={mapTableRows(approver.rows, getBaseColumns())}
//                       columns={getBaseColumns()}
//                       onSelectionChange={(ids) => {
//                         console.log("ids in change", ids);
//                         handleCheckBox(ids, approver);
//                       }}
//                       toolbarRight={[
//                         { filterButton: false },
//                         { DropdownMenu: false },
//                       ]}
//                     />
//                   </Accordian>
//                   <br />
//                 </div>
//               ))}
//             </div>
//           </Accordian>
//         ))}
//       </div>
//       {/* <Modal
//         isOpen={changeApproverModal}
//         onClose={() => setChangeApproverModal(false)}
//         title="Change Approver"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="flex flex-col max-w-[50%] gap-3">
//             <div className="">
//               <FormFieldSet
//                 type={"select"}
//                 title={"User"}
//                 placeholder="Select Approver"
//                 value={user}
//                 onChange={setUser}
//                 options={allSelectEmployeeListOptions}
//                 keyname="employeesSorted"
//                 showSearch
//                 searchValue={allSelectEmployeeSearch}
//                 onClose={resetAllSelectEmployeeSearch}
//                 refData={containerRef}
//                 onSearch={handleSelectEmployeeSearch}
//                 handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
//               />
//             </div>
//             <div>
//               <p>Can submit timesheets on behalf of:</p>
//             </div>
//             <div className="">
//               <FormFieldSet
//                 type={"textArea"}
//                 // placeholder=". Aaron carter (CON-2112)"
//                 placeholder="Selected Employee(s)"
//                 title="Employee(s)"
//                 // value={employee}
//                 // onChange={setEmployee}
//                 value={selectedEmployeeNames.join(", ")}
//                 disabled={true}
//               />
//             </div>
//           </div>
//           <div className="flex gap-3 justify-end">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => {
//                 setUser("");
//                 setChangeApproverModal(false);
//               }}
//             />
//             <Button
//               title={"OK"}
//               // onClick={() => setChangeApproverModal(false)}
//               onClick={handleChangeApprover}
//             />
//           </div>
//         </div>
//       </Modal> */}
//       <Modal
//         isOpen={changeApproverModal}
//         onClose={() => setChangeApproverModal(false)}
//         title="Change Approver"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="flex flex-col max-w-[80%] lg:max-w-[65%] xl:max-w-[50%] gap-3">
//             <div className="">
//               <FormFieldSet
//                 type={"select"}
//                 title={"User"}
//                 placeholder="Select Approver"
//                 value={user}
//                 onChange={setUser}
//                 options={allSelectEmployeeListOptions}
//                 keyname="employeesSorted"
//                 showSearch
//                 searchValue={allSelectEmployeeSearch}
//                 onClose={resetAllSelectEmployeeSearch}
//                 refData={containerRef}
//                 onSearch={handleSelectEmployeeSearch}
//                 handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
//               />
//             </div>
//             <div>
//               <p>Can submit timesheets on behalf of:</p>
//             </div>
//             <div className="">
//               <FormFieldSet
//                 type={"textArea"}
//                 // placeholder=". Aaron carter (CON-2112)"
//                 placeholder="Selected Employee(s)"
//                 title="Employee(s)"
//                 // value={employee}
//                 // onChange={setEmployee}
//                 value={selectedEmployeeNames.join(", ")}
//                 disabled={true}
//               />
//             </div>
//           </div>
//           <div className="flex gap-3 justify-end mt-2">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => {
//                 setUser("");
//                 setChangeApproverModal(false);
//               }}
//             />
//             <Button
//               title={"OK"}
//               // onClick={() => setChangeApproverModal(false)}
//               // onClick={() => handleChangeApprover(approver.key)}
//               onClick={() => handleChangeApprover()}
//             />
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default Approvals;
import React, { useEffect, useRef, useState } from "react";
import {
  Accordian,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  TableAdv,
  showToast,
} from "../../../../components";
import { mapTableRows } from "../../../../utils/mapTableRows";
import { dateFormator, getEmployeeId } from "../../../../utils";
import { accordionData } from "../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import {
  clearEmployeeData,
  getEmployeesStart,
  updateEmployeeStart,
} from "../../../../redux/slices/employee/employeeSlice";
import { getEmployeeName } from "../../../../utils/getDisplays";
import useDropdownData from "../../../../hooks/useDropdownData";

const Approvals = () => {
  // const approvalGroups = [
  //   {
  //     groupTitle: "Internal Approvals",
  //     approvers: [
  //       {
  //         key: "abhiInternal",
  //         name: "Abhi Y",
  //         tableId: "internalAbhi",
  //         rows: JSON.parse(JSON.stringify(accordionData)),
  //       },
  //       {
  //         key: "hemalatheInternal",
  //         name: "Hemalathe Medishetti",
  //         tableId: "internalHemalathe",
  //         rows: JSON.parse(JSON.stringify(accordionData)),
  //       },
  //       {
  //         key: "waseemInternal",
  //         name: "Abdul Waseem Syed",
  //         tableId: "internalWaseem",
  //         rows: JSON.parse(JSON.stringify(accordionData)),
  //       },
  //     ],
  //   },
  // ];
  const [approvalGroups, setApprovalGroups] = useState([]);
  const containerRef = useRef(null);
  const [user, setUser] = useState("");

  const [changeApproverModal, setChangeApproverModal] = useState(false);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);

  const dispatch = useDispatch();
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );
  // dropdown hook
  const {
    data: allSelectEmployeeListOptions,
    searchValue: allSelectEmployeeSearch,
    handleSearch: handleSelectEmployeeSearch,
    resetSearch: resetAllSelectEmployeeSearch,
    handleScroll: handleAllSelectEmployeeScroll,
  } = useDropdownData(
    "employeesSorted",
    10,
    {},
    {
      classification: 2,
    },
  );
  // working one
  // useEffect(() => {
  //   if (!employees?.data?.length) return;

  //   const generateApprovalGroups = async () => {
  //     const approvers = await Promise.all(
  //       employees.data.map(async (emp) => {
  //         let rows = [];

  //         if (emp?.approvalFlow?.approverTo?.length > 0) {
  //           rows = await Promise.all(
  //             emp.approvalFlow.approverTo.map(async (approval) => {
  //               const approver = approval?.approvalFlow?.approvers?.[0]?.uiid;
  //               const approverName = approver
  //                 ? await getEmployeeName(approver)
  //                 : "-";

  //               return {
  //                 uiid: approval?.uiid,
  //                 employeeName: `${approval.firstName} ${
  //                   approval.lastName
  //                 } ${getEmployeeId(approval?.uiid, approval?.employmentType)}`,
  //                 approvals:
  //                   approverName +
  //                   " " +
  //                   getEmployeeId(
  //                     approval?.approvalFlow?.approvers?.[0]?.uiid,
  //                     approval?.approvalFlow?.approvers?.[0]?.employmentType
  //                   ),
  //                 // jobCode: approval?.jobCode || "-",
  //                 // jobTitle: approval?.jobTitle || "-",
  //                 // startDate: approval?.startDate || "-",
  //                 // endDate: approval?.endDate || "-",
  //               };
  //             })
  //           );
  //         }

  //         return {
  //           key: emp.uiid,
  //           name: `${emp.firstName} ${emp.lastName} ${emp.uiid}`,
  //           tableId: `internal${emp.firstName}`,
  //           rows,
  //         };
  //       })
  //     );

  //     setApprovalGroups([
  //       {
  //         groupTitle: "Internal Approvals",
  //         approvers: Array.from(new Set(approvers)),
  //       },
  //     ]);
  //   };

  //   generateApprovalGroups();
  // }, [employees]);
  useEffect(() => {
    if (!employees?.data?.length) return;

    const generateApprovalGroups = async () => {
      const approvers = await Promise.all(
        employees.data.map(async (emp) => {
          let rows = [];

          if (emp?.approvalFlow?.approverTo?.length > 0) {
            rows = await Promise.all(
              emp.approvalFlow.approverTo.map(async (approval) => {
                // const approver = approval?.approvalFlow?.approvers?.[0]?.uiid;
                // const approverName = approver
                //   ? await getEmployeeName(approver)
                //   : "-";

                return {
                  id: approval?.uiid, // Add id field for TableAdv
                  uiid: approval?.uiid,
                  employeeName:
                    `${approval.firstName} ${approval.lastName} ${getEmployeeId(
                      approval?.uiid,
                      approval?.employmentType,
                    )}` || "-",
                  approvals:
                    approval?.approvalFlow?.approvers?.[0]?.firstName +
                    " " +
                    approval?.approvalFlow?.approvers?.[0]?.lastName +
                    " " +
                    getEmployeeId(
                      approval?.approvalFlow?.approvers?.[0]?.uiid,
                      approval?.approvalFlow?.approvers?.[0]?.employmentType,
                    ),
                  // jobCode: approval?.jobCode || "-",
                  // jobTitle: approval?.jobTitle || "-",
                  // startDate: approval?.startDate || "-",
                  // endDate: approval?.endDate || "-",
                };
              }),
            );
          }

          return {
            key: emp.uiid,
            name: `${emp.firstName} ${emp.lastName}`,
            tableId: `internal${emp.firstName}`,
            rows,
          };
        }),
      );

      setApprovalGroups([
        {
          groupTitle: "Internal Approvals",
          approvers: Array.from(new Set(approvers)),
        },
      ]);
    };

    generateApprovalGroups();
  }, [employees]);

  useEffect(() => {
    dispatch(
      getEmployeesStart({
        page: 1,
        limit: 20,
        filters: {
          classification: {
            type: "NONE",
            value: 2,
          },
        },
        sort: { uiid: -1 },
        // sort: { uiid: 1 },
        ret: "uiid firstName lastName approvalFlow employmentType",
        ref: "Approved_Approver",
        incl: "uiid firstName lastName employmentType",
      }),
    );
    return () => {
      dispatch(clearEmployeeData());
    };
  }, [dispatch]);

  const initialOpenStates = {};
  approvalGroups.forEach((group) =>
    group.approvers.forEach((a) => {
      initialOpenStates[a.key] = false;
    }),
  );

  const [openStates, setOpenStates] = useState(initialOpenStates);

  // Initialize selection tracking for each approver
  useEffect(() => {
    const initialSelections = {};
    approvalGroups.forEach((group) =>
      group.approvers.forEach((a) => {
        initialSelections[a.key] = [];
      }),
    );
    setSelectedRowsByApprover(initialSelections);
  }, [approvalGroups]);

  const toggleAccordion = (key) =>
    setOpenStates((prev) => ({ ...prev, [key]: !prev[key] }));

  const getBaseColumns = () => [
    { key: "employeeName", label: "Employee Name", sortable: false },
    // { key: "jobCode", label: "Job Code", sortable: false },
    // { key: "jobTitle", label: "Job Title", sortable: false },
    // {
    //   key: "startDate",
    //   label: "Start Date",
    //   render: (row) => dateFormator(row.startDate, "month-day-year"),
    //   sortable: false,
    // },
    // {
    //   key: "endDate",
    //   label: "End Date",
    //   render: (row) => dateFormator(row.endDate, "month-day-year"),
    //   sortable: false,
    // },
    { key: "approvals", label: "Approvals", sortable: false },
  ];

  const [selectedApprover, setSelectedApprover] = useState(null);
  const [selectedRowsByApprover, setSelectedRowsByApprover] = useState({});
  
  const handleCheckBox = (selectedRowIds, approver) => {
    if (!approver.key) {
      showToast("Please select an employee", "error", 5000);
      return;
    }
    
    console.log("Approver key:", approver.key);
    console.log("Selected row IDs:", selectedRowIds);
    console.log("Available rows:", approver.rows);
    
    setSelectedApprover(approver.key);
    
    // Store the selection for this specific approver
    setSelectedRowsByApprover(prev => ({
      ...prev,
      [approver.key]: selectedRowIds
    }));
    
    try {
      // Find the actual row objects from the approver's rows
      const selectedRowObjects = approver.rows.filter((row) => 
        selectedRowIds.includes(row.id || row.uiid)
      );
      
      console.log("Selected row objects:", selectedRowObjects);
      
      const employeeIds = selectedRowObjects.map((row) => row.uiid);
      const employeeNames = selectedRowObjects.map((row) => row.employeeName);
      
      console.log("Employee IDs:", employeeIds);
      console.log("Employee Names:", employeeNames);
      
      setSelectedEmployeeIds(employeeIds);
      setSelectedEmployeeNames(employeeNames);
    } catch (error) {
      console.error("Error processing selection:", error);
    }
  };

  const handleChangeApprover = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("Please select an employee", "error", 5000);
      return;
    }

    try {
      for (const id of selectedEmployeeIds) {
        try {
          await Promise.all([
            dispatch(
              updateEmployeeStart({
                coll: "Employee",
                uiid: id,
                payload: [
                  {
                    type: "SET",
                    value: { "approvalFlow.approvers.0": user },
                  },
                ],
              }),
            ),
            dispatch(
              updateEmployeeStart({
                coll: "Employee",
                uiid: user,
                payload: [
                  {
                    type: "PUSH",
                    value: {
                      "approvalFlow.approverTo": id,
                    },
                  },
                ],
              }),
            ),
            dispatch(
              updateEmployeeStart({
                coll: "Employee",
                uiid: selectedApprover,
                payload: [
                  {
                    type: "PULL",
                    value: {
                      "approvalFlow.approverTo": id,
                      // "approvalFlow.approverTo": selectedApprover,
                    },
                  },
                ],
              }),
            ),
          ]).then(() => {
            setUser("");
            setChangeApproverModal(false);

            setTimeout(() => {
              dispatch(
                getEmployeesStart({
                  page: 1,
                  limit: 20,
                  filters: {
                    classification: {
                      type: "NONE",
                      value: 2,
                    },
                  },
                  sort: { uiid: -1 },
                  // sort: { uiid: 1 },
                  ret: "uiid firstName lastName approvalFlow employmentType",
                  ref: "Approved_Approver",
                  incl: "uiid firstName lastName employmentType",
                }),
              );
            }, 1200);
          });
        } catch (err) {
          showToast(`Failed to update employee ${id}`, "error", 5000);
          console.error(`Error updating employee ${id}:`, err);
          throw err; // Remove this line if you want to continue even after one fails
        }
      }
    } catch (finalError) {
      showToast("Bulk update failed. Please try again later.", "error", 5000);
      console.error("Bulk update error:", finalError);
    }
  };

  return (
    <div className="py-3 pl-2 overflow-auto">
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <div className="flex justify-end">
        <Button
          variant="contained"
          size="sm"
          title="Change Approver"
          color="black"
          icon="person_add"
          onClick={() => setChangeApproverModal(true)}
        />
      </div>

      <div className="space-y-3 mt-3">
        {approvalGroups.map((group) => (
          <Accordian
            key={group.groupTitle}
            title={group.groupTitle}
            iconColor="black"
            color="white"
            rounded="md"
          >
            <div className="space-y-1 overflow-auto">
              {group.approvers.map((approver) => (
                <div
                  key={approver.key}
                  className={openStates[approver.key] ? "" : "inline-flex m-2"}
                >
                  <Accordian
                    title={approver.name}
                    iconType="variant"
                    iconColor="black"
                    rounded="md"
                    color="primary"
                    handleChangeOption={() => {
                      // Clear selections for this specific approver
                      setSelectedRowsByApprover(prev => ({
                        ...prev,
                        [approver.key]: []
                      }));
                      setSelectedEmployeeIds([]);
                      setSelectedEmployeeNames([]);
                      toggleAccordion(approver.key);
                    }}
                    bodyPadding="px-0 py-0"
                  >
                    <TableAdv
                      tableId={approver.tableId}
                      showCheckbox
                      rows={mapTableRows(approver.rows, getBaseColumns())}
                      columns={getBaseColumns()}
                      defaultSelectedRows={selectedRowsByApprover[approver.key] || []}
                      onSelectionChange={(selectedRowIds) => {
                        console.log("Selected row IDs:", selectedRowIds);
                        handleCheckBox(selectedRowIds, approver);
                      }}
                      
                    />
                  </Accordian>
                  <br />
                </div>
              ))}
            </div>
          </Accordian>
        ))}
      </div>

      <Modal
        isOpen={changeApproverModal}
        onClose={() => setChangeApproverModal(false)}
        title="Change Approver"
        width="max-w-4xl"
      >
        <div>
          <div className="flex flex-col max-w-[80%] lg:max-w-[65%] xl:max-w-[50%] gap-3">
            <div className="">
              <FormFieldSet
                type={"select"}
                title={"User"}
                placeholder="Select Approver"
                value={user}
                onChange={setUser}
                options={allSelectEmployeeListOptions}
                keyname="employeesSorted"
                showSearch
                searchValue={allSelectEmployeeSearch}
                onClose={resetAllSelectEmployeeSearch}
                refData={containerRef}
                onSearch={handleSelectEmployeeSearch}
                handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
              />
            </div>
            <div>
              <p>Can submit timesheets on behalf of:</p>
            </div>
            <div className="">
              <FormFieldSet
                type={"textArea"}
                // placeholder=". Aaron carter (CON-2112)"
                placeholder="Selected Employee(s)"
                title="Employee(s)"
                // value={employee}
                // onChange={setEmployee}
                value={selectedEmployeeNames.join(", ")}
                disabled={true}
              />
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-2">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => {
                setUser("");
                setChangeApproverModal(false);
              }}
            />
            <Button
              title={"OK"}
              // onClick={() => setChangeApproverModal(false)}
              // onClick={() => handleChangeApprover(approver.key)}
              onClick={() => handleChangeApprover()}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Approvals;
